import * as React from 'react';
import './SubTitle.scss';

const SubTitle: React.SFC<{}> = ({ children }) => {
  return <p className="SubTitle">{children}</p>;
};

export default SubTitle;
